import type { Entity } from '@carboncopyco/types';
import { Debug, removeUndefinedValues } from '@carboncopyco/utils';
import { mainApi } from './mainApi';

Debug.extend('demostack-data:api:downloadApi');

export interface GetDesktopDownloadLinkArgs {
  platform: string;
  version?: string;
}

export interface GetDesktopDownloadLinkResponse {
  downloadLink: string;
}
export type RequestType = 'one_demo' | 'one_tour';

export interface GetCsvDownloadUrlArgs {
  organizationId: string;
  requestType: RequestType;
  entityType: Extract<Entity, 'demo' | 'tour'>;
  entityId: string;
  tzName?: string;
}

export interface GetCsvDownloadUrlResponse {
  signedUrl: string;
}

const downloadApi = mainApi.injectEndpoints({
  endpoints: (builder) => ({
    getDesktopDownloadLink: builder.query<
      GetDesktopDownloadLinkResponse,
      GetDesktopDownloadLinkArgs
    >({
      query: ({ platform, version }) => ({
        url: '/api/desktop-app/download',
        method: 'GET',
        params: removeUndefinedValues({
          platform,
          version,
        }),
      }),
    }),
    getCsvDownloadUrl: builder.query<
      GetCsvDownloadUrlResponse,
      GetCsvDownloadUrlArgs
    >({
      query: ({
        organizationId,
        requestType,
        entityType,
        entityId,
        tzName,
      }) => ({
        url: `/api/${organizationId}/${requestType}/${entityType}/${entityId}/download`,
        method: 'GET',
        params: removeUndefinedValues({ tzName }),
      }),
    }),
  }),
});

export const {
  useGetDesktopDownloadLinkQuery,
  useLazyGetDesktopDownloadLinkQuery,
  useLazyGetCsvDownloadUrlQuery,
} = downloadApi;
